import { render, staticRenderFns } from "./recordForm.vue?vue&type=template&id=b9000418&scoped=true&"
import script from "./recordForm.vue?vue&type=script&lang=ts&"
export * from "./recordForm.vue?vue&type=script&lang=ts&"
import style0 from "./recordForm.vue?vue&type=style&index=0&id=b9000418&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9000418",
  null
  
)

export default component.exports